export default __webpack_public_path__ + "static/vacuumlabs-fa55990b22ec3366beb0ae0e8366e915.png";